/* 🤖 this file was generated by svg-to-ts */
export const matIconTvOff: {
  name: 'tv-off';
  data: string;
} = {
  name: 'tv-off',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M21 7v10.88l1.85 1.85c.09-.23.15-.47.15-.73V7c0-1.11-.89-2-2-2h-7.58l3.29-3.3L16 1l-4 4-4-4-.7.7L10.58 5H8.12l2 2H21zm-.54 16 1.26-1.27-1.26 1.26zM2.41 2.13l-.14.14L1 3.54l1.53 1.53C1.65 5.28 1 6.06 1 7v12c0 1.1.9 2 2 2h15.46l1.99 1.99 1.26-1.26.15-.15L2.41 2.13zM3 19V7h1.46l12 12H3z"/></svg>`
};
